/**
 * cmp-media-gallery.js
 * Pairs with snippets/cmp-product-media-gallery.liquid and
 * snippets/cmp-product-media-modal.liquid (sections/custom-main-product.liquid).
 *
 * Extends Dawn's <media-gallery> (assets/media-gallery.js, which must load
 * first) as <cmp-media-gallery>. The media set now depends on the selected
 * variant (featured media + custom.additional_images, or all product media),
 * so on every variantChange the freshly server-rendered gallery replaces
 * this one outright. Inserting the new nodes re-runs the constructors of
 * <cmp-media-gallery>, both <slider-component>s, <modal-opener> and
 * <deferred-media>, which re-initialises the carousel and thumbnails.
 *
 * product-info.js's own updateMedia() only targets <media-gallery>, and
 * skips the modal when the variant has no featured media, so the modal
 * content is refreshed here too.
 */
if (!customElements.get('cmp-media-gallery') && customElements.get('media-gallery')) {
  customElements.define(
    'cmp-media-gallery',
    class CmpMediaGallery extends customElements.get('media-gallery') {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.unsubscribeVariantChange?.();
      }

      onVariantChange({ data: { sectionId, html } }) {
        if (sectionId !== this.dataset.section || !html) return;

        this.updateModal(html);

        const newGallery = html.getElementById(this.id);
        if (!newGallery || newGallery.dataset.galleryKey === this.dataset.galleryKey) return;

        this.replaceWith(newGallery);
        if (typeof enableZoomOnHover === 'function') enableZoomOnHover(2);
      }

      updateModal(html) {
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        const newModalContent = html.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }
    }
  );
}
